'use strict';

import type { UserOffice } from '../../Entities/User/UserOffice';
import { EntityCollection } from '../EntityCollection';

export class UserOfficeCollection extends EntityCollection<UserOffice> {}
